// extracted by mini-css-extract-plugin
export var author = "index-module--author--iSkDD";
export var authorDateContainer = "index-module--authorDateContainer--P5u5I";
export var center = "index-module--center--s+9sA";
export var date = "index-module--date--MTT80";
export var description = "index-module--description--C3tx8";
export var hero = "index-module--hero--QL4LV";
export var inner = "index-module--inner--GYh1G";
export var left = "index-module--left--S4JHR";
export var ousterBlogPrimaryCard = "index-module--ousterBlogPrimaryCard--hijqc";
export var outer = "index-module--outer--DMV-b";
export var primaryCard = "index-module--primaryCard--xg4JN";
export var readMore = "index-module--readMore--INAOc";
export var readMoreArrow = "index-module--readMoreArrow--ejMXc";
export var right = "index-module--right--ksGFa";
export var title = "index-module--title--XQ8Ww";
export var titleContainer = "index-module--titleContainer--5IqxC";